import React from 'react';
import SIcon from './SIcon';
import { faSignal } from '@fortawesome/pro-duotone-svg-icons';

const Icon = props => <SIcon {...props} icon={faSignal} fa />;

export default Icon;
